"use strict";
$(function ($) {
  /* ドロワーメニュー */
   /* ----- 簡単なハンバーガーメニュー ----- */
  $('#js-hamburger').on('click', function () {
    $('#js-hamburger, #js-drawer-menu').toggleClass('is-openSP');
  });

  $("#js-hamburger").click(function () {
    $(this).toggleClass('active');
  });

  // ハンバーガーメニュー内をクリックしらたらハンバーガーメニューを閉じる
  $('#js-drawer-menu a[href]').on('click', function () {
    $('#js-hamburger').trigger('click')
  });
});

/* ----- ヘッダーシャドー ----- */
$(function () {
  $(window).on('scroll', function () {
    if ($('.fv, .fvSub').height() < $(this).scrollTop()) {
      $('.header').addClass('change-color');
    } else {
      $('.header').removeClass('change-color');
    }
  });
});

/* ----- mega-menu ----- */
// $(function ($) {
//   $('.megaMenu__btn').click(function() {
//     $(this).next().stop().slideToggle(450);
//     $(this).find('span').toggleClass('is-active');
//   });
// });
$(function ($) {
  $('.megaMenu__btn-hair').click(function() {
    $(this).find('span').toggleClass('is-active');
    $('.megaMenu__hair').toggleClass('is-active');
  });

  $('.megaMenu__hair').mouseleave(function() {
    $(this).removeClass('is-active');
    $('.megaMenu__btn-hair').find('span').removeClass('is-active');
  });
});

$(function ($) {
  $('.megaMenu__btn-salon').click(function() {
    $(this).find('span').toggleClass('is-active');
    $('.megaMenu__salon').toggleClass('is-active');
  });

  $('.megaMenu__salon').mouseleave(function() {
    $(this).removeClass('is-active');
    $('.megaMenu__btn-salon').find('span').removeClass('is-active');
  });
});


$(function ($) {
  $('.headerSp__btn').click(function() {
    $(this).next().stop().slideToggle(450);
    $(this).find('span').toggleClass('is-active');
  });
});

/* qa accordion */
$('.qa__question').click(function() {
  $(this).next().stop().slideToggle(400);
    $(this).toggleClass('is-active');
});

/* 募集要項 accordion */
$('.recruit__title').click(function() {
  $(this).next().stop().slideToggle(400);
    $(this).toggleClass('is-active');
});


/* ----- fvースライダー ----- */
if (document.body.classList.contains('top-page')) {
  const splide = new Splide(".splide__fv", {
    // Splideの設定
    type: "fade", // フェード
    autoplay: true, // 自動再生
    rewind: true, // スライダーの終わりまで行ったら先頭に巻き戻す
    pauseOnHover: false,
    pauseOnFocus: false,
    arrows: false, // 矢印ボタンを非表示
    interval: 5000,
    speed: 2000,
    perPage: 1,
    classes: {
      pagination: "splide__pagination your-class-pagination",
      page: "splide__pagination__page your-class-page",
    },
  }).mount();
}

/* ----- ギャラリースライダー ----- */
if (document.body.classList.contains('top-page')) {
  const splide = new Splide(".topGallery__splide", {
    // Splideの設定
    autoplay: true, // 自動再生
    type: "loop",
    pauseOnHover: false,
    pauseOnFocus: false,
    interval: 4000,
    speed: 1000,
    padding: "2rem",
    perPage: 4,
    pagination: false,  // ページネーションを非表示に設定
    gap: 20,
    classes: {
      // pagination: "splide__pagination your-class-pagination",
      page: "splide__pagination__page your-class-page",
    },
    breakpoints: {
      767: {
        focus: 'center', // スライドを中央に配置
        perPage: 1,  // 767px以下のときに1ページに表示するスライドの数を1に設定
        padding: '2rem',  // ここも必要に応じて調整してください
      }
    },
  }).mount();
}


/* ----- スムースクロール ----- */
const headerHeight = $('header').outerHeight();
$('a[href^="#"]').click(function(event) {
    event.preventDefault();  // デフォルトのリンクの動作を無効化
    const href = $(this).attr("href");
    const target = $(href === "#" || href === "" ? 'html' : href);
    const position = target.offset().top - headerHeight;
    $('body,html').stop().animate({scrollTop: position}, 500, 'swing');
});


/* ----- モーダル ----- */
const modalButtons = document.querySelectorAll('.js-modal-open');
const modals = document.querySelectorAll('.js-modal');
const closeButton = document.querySelectorAll('.js-modal-close');
const body = document.body;

function openModal(index) {
  modals[index].classList.add('is-open');
  body.style.overflow = 'hidden'; // スクロールを禁止する
}

function closeModal(index) {
  modals[index].classList.remove('is-open');
  body.style.overflow = ''; // スクロールを許可する
}

modalButtons.forEach((button, index) => {
  button.addEventListener('click', () => {
    openModal(index);
  });
});

closeButton.forEach((button, index) => {
  button.addEventListener('click', () => {
    closeModal(index);
  });
});

modals.forEach((modal, index) => {
  modal.addEventListener('click', event => {
    if (event.target === modal) {
      closeModal(index);
    }
  });
});

window.addEventListener('keydown', event => {
  if (event.key === 'Escape') {
    modals.forEach((modal, index) => {
      if (modal.classList.contains('is-open')) {
        closeModal(index);
      }
    });
  }
});


/* ----- フェードイン ----- */
window.addEventListener('scroll', function(){
  // スクロール量を取得
  const scroll = window.scrollY;
  // 画面の高さを取得
  const windowHeight = window.innerHeight;
  // すべての.boxを取得
  const boxes = document.querySelectorAll('.fade');

  boxes.forEach(function(box) {
    // boxまでの高さを取得
    const distanceToBox = box.offsetTop;
    // 下記条件が成り立つときだけboxにis-activeクラスを付与する
    if(scroll + windowHeight > distanceToBox) {
      box.classList.add('is-active');
    }
  });
});



document.addEventListener('DOMContentLoaded', function() {
  if (document.body.classList.contains('top-page')) {
    const childcareBtn = document.querySelector('.fv__childcare-btn');
    const fvElement = document.querySelector('.fv');

    if (childcareBtn && fvElement) {
      const fvHeight = fvElement.offsetHeight;

      function checkPosition() {
        if (window.scrollY > fvHeight) {
          childcareBtn.style.opacity = '1';
        } else {
          childcareBtn.style.opacity = '0';
        }
      }
      window.addEventListener('scroll', checkPosition);
      // 初期表示を設定
      checkPosition();
    } else {
      console.error('必要な要素が見つかりませんでした');
    }
  }
});
